import * as THREE from 'three';
import PianoUtil from '@/util/piano-util';
import game from '@/model/game';
// import SpriteAnimation from './sprite-animation';
const KEY_WIDTH = 15, KEY_HEIGHT = 30, PADDING = 2;

let OFFSET = (KEY_WIDTH + PADDING) * 7 / 2;
const OCTAVE_WIDTH = (KEY_WIDTH + PADDING) * 7
const RAY_COLOR = game.settings.rayMaterialColor, 
keyColorWhite = game.settings.whiteGemColor, 
keyColorBlack = game.settings.blackGemColor;

export const RAY_MATERIAL = new THREE.MeshBasicMaterial({ 
    color: RAY_COLOR, 
    transparent: true, 
    opacity: 1 });

function buildWhiteKey(x, keyNumber) {
    let geometry = new THREE.BoxGeometry(KEY_WIDTH, KEY_HEIGHT, 10);
    let material = new THREE.MeshBasicMaterial(
        { color: keyColorWhite, wireframe: false }
    );
    material.__defaultColor = new THREE.Color(keyColorWhite);
    let mesh = new THREE.Mesh(geometry, material);
    const container = new THREE.Group();
    container.add(mesh)
    // the colorful ray that highlights the column in chart
    let rayGeometry = new THREE.BoxGeometry(KEY_WIDTH, 99999, 2);
    const rayMaterial = RAY_MATERIAL;
    let rayMesh = new THREE.Mesh(rayGeometry, rayMaterial);
    mesh.position.set(x, 0, 0);
    rayMesh.position.x = x;
    rayMesh.position.y = 0;
    rayMesh.position.z = -5;
    container.add(rayMesh);
    container.keyNumber = keyNumber;
    rayMesh.visible = true;

    // const flame = SpriteAnimation.build('fire1_64.png');
    // flame.position.z = 4;
    // flame.position.y = 50;
    // flame.position.x = keyIndex * (KEY_WIDTH + PADDING) + OCTAVE_WIDTH * octave - offset;
    // container.add(flame);
    return { mesh: container, ray: rayMesh};
}

function buildBlackKey(x, keyNumber) {
    x-= KEY_WIDTH / 2;
    let geometry = new THREE.BoxGeometry(KEY_WIDTH, KEY_HEIGHT * 0.8, 10);
    let material = new THREE.MeshBasicMaterial(
        { color: keyColorBlack, wireframe: false }
    );
    material.__defaultColor = new THREE.Color(keyColorBlack);
    const container = new THREE.Group();
    let mesh = new THREE.Mesh(geometry, material);
    container.add(mesh);
    // the colorful ray that highlights the column in chart
    let rayGeometry = new THREE.BoxGeometry(KEY_WIDTH / 4, 99999, 2);
    const rayMaterial = RAY_MATERIAL;
    let rayMesh = new THREE.Mesh(rayGeometry, rayMaterial);
    mesh.position.set(x, 10, 3);
    rayMesh.position.x = x;
    rayMesh.position.y = 0;
    rayMesh.position.z = -5;
    container.keyNumber = keyNumber;
    container.add(rayMesh);

    // const flame = SpriteAnimation.build('fire1_64.png');
    // flame.position.z = 4;
    // flame.position.y = 50;
    // flame.position.x = KEY_WIDTH / 2 + keyIndex * (KEY_WIDTH + PADDING) + OCTAVE_WIDTH * octave - offset;
    // flame.visible = false;
    // container.add(flame);

    return { mesh: container, ray: rayMesh};
}

class Piano3D {
    build({ min, max }) {
        const group = new THREE.Group();
        const keysToRender = { black: [], white: [] };
        OFFSET = PianoUtil.whiteKeysBetween(min, max) * (KEY_WIDTH + PADDING) / 2;
        let x = OFFSET;
        for (let i = min; i <= max; i++) {
            const isBlackKey = PianoUtil.isBlackKey(i);
            let width = isBlackKey ? KEY_WIDTH / 2 : KEY_WIDTH;
            let height = isBlackKey ? KEY_HEIGHT * 0.7 : KEY_HEIGHT;
            if (isBlackKey) {
                keysToRender.black.push({ x, y: 0, width, height, keyNumber: i });
            } else {
                keysToRender.white.push({ x, y: 0, width, height, keyNumber: i });
                x += width + PADDING;
            }
        }

        group.highlights = {};
        group.keys = {};
        keysToRender.white.forEach(({ x, keyNumber }) => {
            const {mesh, ray} = buildWhiteKey(x, keyNumber);
            group.highlights[keyNumber] = ray;
            ray.visible = false;
            group.keys[keyNumber] = mesh;
            group.add(mesh);
        });
        keysToRender.black.forEach(({ x, keyNumber }) => {
            const {mesh, ray} = buildBlackKey(x, keyNumber);
            ray.visible = false;
            group.highlights[keyNumber] = ray;
            group.keys[keyNumber] = mesh;
            group.add(mesh);
        });
        group.position.set(0 - (x + KEY_WIDTH + OFFSET) / 2, -60 - 30, -35);
        return group;
    }
}

export default new Piano3D();